module.exports = Em.Handlebars.compile("{{application-error error=model.message}}\n");